export default function getCiiGrade(cii, ciiRatings) {
  if (!ciiRatings || !cii) {
    return null;
  }
  const aRating = ciiRatings.aRating;
  const bRating = ciiRatings.bRating;
  const cRating = ciiRatings.cRating;
  const dRating = ciiRatings.dRating;

  if (cii <= aRating) return "A";
  if (cii > aRating && cii <= bRating) return "B";
  if (cii > bRating && cii <= cRating) return "C";
  if (cii > cRating && cii <= dRating) return "D";
  else return "E";
}
